import Skeleton from '@/components/ui/skeleton/skeleton';
export default Skeleton;
